import * as React from "react";
import useLocalStorage from "../../../hooks/useLocalstorage";
import config from "../../../config";
import { useSelector } from "react-redux";

const DraftContext = React.createContext();

const KoTDraftB2bProvider = ({ children, ...props }) => {
  const [draftBill, setDraftBill] = useLocalStorage("kotdraftB2bBill", []);
  const [draftBillCatch, setDraftBillCatch] = useLocalStorage(
    "billingDraftCatch",
    []
  );
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const value = [draftBill, setDraftBill, draftBillCatch, setDraftBillCatch];
  const employeeId = useSelector((state) => state.shopDetails.empId);

  React.useEffect(() => {
    (async function (shopId, employeeId) {
      const getDraft = async () => {
        try {
          const res = await fetch(`${config.newApiGateway}/draft/draft`, {
            method: "POST",
            body: JSON.stringify({
              action: "getDraft",
              shopId: shopId,
              employeeId: employeeId ? employeeId : "",
              shopTypeandCustomertype: "restaurant-b2b",
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();
          if (data.status === "SUCCESS") {
            setDraftBill(data.data);
          }
        } catch (error) {
          console.log("getRestaurantDraftError", error);
        }
      };
      getDraft();
    })(shopId, employeeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, employeeId]);

  return (
    <DraftContext.Provider value={value} {...props}>
      {children}
    </DraftContext.Provider>
  );
};

export default KoTDraftB2bProvider;

export const useKotDraftB2b = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(`useBilling must be used within a KoTDraftB2bProvider`);
  }
  return context;
};

export const useKotDraftB2bWithCatch = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(
      `useKotDraftB2bWithCatch must be used within a KoTDraftB2bProvider`
    );
  }
  return [context[2], context[3]];
};
